import React from "react";
import PropTypes from "prop-types";
import ModelTaskTableBodyRow from "./ModelTaskTableBodyRow";
import { ACTION_ROW_HEIGHT } from "./rowConstants";

const previousPageLabel = (previousPage) => {
	if (previousPage.isError) return "Retry previous tasks";
	if (previousPage.isFetching) return "Loading…";
	return "Load previous tasks";
};

const PreviousPageRow = ({ previousPage, columnCount, classes }) => {
	if (!previousPage.hasPage) return null;
	return (
		<ModelTaskTableBodyRow
			columnCount={columnCount}
			height={ACTION_ROW_HEIGHT}
			className={previousPage.isFetching ? classes.tableActionBusy : classes.tableAction}
			onClick={previousPage.isFetching ? undefined : previousPage.fetch}
		>
			{previousPageLabel(previousPage)}
		</ModelTaskTableBodyRow>
	);
};

PreviousPageRow.propTypes = {
	previousPage: PropTypes.shape({
		hasPage: PropTypes.bool.isRequired,
		isFetching: PropTypes.bool.isRequired,
		isError: PropTypes.bool.isRequired,
		fetch: PropTypes.func.isRequired,
	}).isRequired,
	columnCount: PropTypes.number.isRequired,
	classes: PropTypes.object.isRequired,
};

export default PreviousPageRow;
